import './Specifications.scss';
import SpecificationsToolbar from './Toolbar/SpecificationsToolbar';
import Analytics from './Analytics/Analytics';
import React from 'react';

export default function CarModelSpecifications({ fields }) {
  return (
    <div className={'container car-model-specifications'}>
      <div className={'wrapper,container'}>
        <SpecificationsToolbar field={fields} />
        <Analytics options={fields.analytics} />
      </div>
    </div>
  );
}
